import '../../assets/table.css'; 

const Payment = ({ t, receiptData  }) => {

    const datas = receiptData.filter((data) => {
        return data.moduleType === 'GOV_ENTITY';
    });
    return (
        <div className="card card-custom card-stretch gutter-b">
            <div className="card-body pb-3">
                <h3 className="card-title font-weight-bolder text-dark">{t("jobsManagement.infoJob.payments.title")}</h3>
                <div className="d-flex mt-2">

                    {(datas.length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : <div className="table-responsive">

                        <table className="table tableFreez table-head-custom table-vertical-center table-head-bg">
                            <thead>
                                <tr className="text-left">
                                    <th className="pl-7" style={{width: '50px'}}>{t("jobsManagement.infoJob.references.sNo")}</th>
                                    <th className="text-center" style={{width: '500px'}}>{t("jobsManagement.infoJob.payments.name")}</th>
                                    <th className="text-center" style={{width: '500px'}}>{t("jobsManagement.infoJob.payments.amount")}</th>
                                </tr>
                            </thead>
                            <tbody>

                                {datas.map((data, index) => {
                                    return (
                                    <tr key={index}>
                                        <td className="pl-7">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{index+1}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{data.name}</span>
                                        </td>
                                        <td className="text-center">
                                            <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{data.amount}</span>
                                        </td>
                                    </tr>
                                    )})}

                            </tbody>
                        </table>
                    </div>}
                </div>
            </div>
        </div>
    );
};

export default Payment;